<script setup lang="ts">
const props = defineProps<{
  backgroundUrl: string;
}>();

const solutionsDetailsTitle = ref<HTMLElement>();
const backgroundVideo = ref<HTMLVideoElement>();

let itemObserver: IntersectionObserver | null = null;

onMounted((): void => {
  document.addEventListener("visibilitychange", () => {
    if (backgroundVideo.value) {
      if (document.visibilityState === "visible") {
        backgroundVideo.value.play();
      } else {
        backgroundVideo.value.pause();
      }
    }
  });

  itemObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (backgroundVideo.value) {
        if (entry.isIntersecting) {
          backgroundVideo.value.play();
        } else {
          backgroundVideo.value.pause();
        }
      }
    });
  });

  itemObserver.observe(solutionsDetailsTitle.value!);
});
</script>

<template>
  <div ref="solutionsDetailsTitle" class="solutions-details-title">
    <div class="video-bg-container">
      <video
        ref="backgroundVideo"
        class="video-bg"
        autoplay
        playsinline
        muted
        loop
        :poster="props.backgroundUrl"
      >
        <slot name="videos" />
      </video>
      <div class="title-content">
        <h2><slot name="subTitle">SOLUTIONS</slot></h2>
        <h1><slot name="title" /></h1>
        <p>
          <slot name="description" />
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.solutions-details-title {
  align-items: center;
  background-position: center;
  background-size: cover;
  display: flex;
  height: calc(100vh - 89px);
  justify-content: center;
  overflow: hidden;
  width: 100%;

  .video-bg-container {
    height: calc(100vh - 89px);
    overflow: hidden;
    position: relative;
    width: 100%;

    @media only screen and (max-device-width: 600px) {
      width: 100%;
    }

    .video-bg {
      height: 100vh;
      object-fit: cover;
      width: 100vw;
    }

    .title-content {
      background-color: rgba(0, 0, 0, 0.7);
      border-left: 1px dotted white;
      bottom: 22%;
      display: flex;
      flex-direction: column;
      gap: 5rem;
      left: 10%;
      max-width: 50%;
      padding: 1rem;
      padding-left: 1rem;
      position: absolute;
      width: 100%;
      z-index: 1;

      @media (max-width: 900px) {
        margin-top: 4rem;
        max-width: 90%;
      }

      @media only screen and (max-device-width: 600px) {
        bottom: auto;
        top: 0;
      }

      @media only screen and (orientation: landscape) and (max-device-width: 768px) {
        bottom: 120px;
      }

      &:before {
        background-color: #6734bb;
        content: "";
        height: 20px;
        left: -3.5rem;
        position: absolute;
        top: 0;
        width: 20px;
      }

      h1,
      h2 {
        font-size: min(10vw, 5.2rem) !important;
        line-height: 1;
        margin: 0;
        padding: 0;
      }

      h2 {
        color: gray;
        // font-size: 4rem;
        font-size: min(7vw, 4rem);
      }

      h1 {
        color: white;
        font-size: 6rem;
        font-weight: 200;
        line-height: 0.9;
      }

      p {
        color: white;
        // font-size: 3rem;
        font-size: min(6vw, 3rem);
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>
